import { ProcessCommandActionSettings } from '../../models/ProcessCommandActionSettings';
import { ActionType } from '../../models/Action';
import { ActionViewModel } from '../../models/viewModels/ActionViewModel';
import { WhatsappConstants } from 'modules/application/detail/channels/whatsapp/WhatsappConstants';
import { CommandMethods } from 'types/CommandMethods';
import { Condition, ConditionComparison, ValueSource, } from '../../models/Condition';
import { SmartSalesConstants } from '../SmartSalesConstants';
import { ExecuteScriptActionSettings } from '../../models/ExecuteScriptActionSettings';
import { ProcessHttpActionSettings } from '../../models/ProcessHttpActionSettings';
import { HttpVerbs } from 'types/HttpVerbs';
import { SetVariableActionSettings } from '../../models/SetVariableActionSettings';
import { TrackEventActionSettings } from '../../models/TrackEventActionSettings';
const WHATSAPP_DOMAIN = '@wa.gw.msging.net';
export const getSmartSalesEnteringCustomActions = ({ token, waCtaMessage, defaultDisabledCtaMsg }) => [
    new ActionViewModel({
        type: ActionType.ProcessHttp,
        $title: 'smartSalesCatalogUrlResponse',
        $invalid: false,
        settings: new ProcessHttpActionSettings({
            method: HttpVerbs.GET,
            uri: `${SmartSalesConstants.API_BASE_URL}/Bot/catalog`,
            headers: {
                Token: token,
                Identity: '{{contact.identity}}',
                StateId: '{{state.id}}',
            },
            responseBodyVariable: 'smartSalesCatalogUrlResponse',
            responseStatusVariable: 'smartSalesCatalogUrlStatus',
        }),
    }),
    new ActionViewModel({
        type: ActionType.ProcessCommand,
        $title: 'smartSalesWabaResponse',
        $invalid: false,
        settings: new ProcessCommandActionSettings({
            to: WhatsappConstants.WHATSAPP_GATEWAY_IDENTITY,
            method: CommandMethods.get,
            uri: '/wabas/details',
            variable: 'smartSalesWabaResponse',
        }),
        conditions: [
            new Condition({
                source: ValueSource.Context,
                comparison: ConditionComparison.Contains,
                variable: 'contact.identity',
                values: [WHATSAPP_DOMAIN],
            }),
        ],
    }),
    new ActionViewModel({
        type: ActionType.SetVariable,
        $title: SmartSalesConstants.WA_CTA_ACTION_NAME,
        settings: new SetVariableActionSettings({
            variable: 'smartSalesWhatsappCta',
            value: JSON.stringify(waCtaMessage),
        }),
    }),
    new ActionViewModel({
        type: ActionType.SetVariable,
        $title: SmartSalesConstants.WA_WEB_ACTION_NAME,
        settings: new SetVariableActionSettings({
            variable: 'isCtaEnabled',
            value: 'true',
        }),
    }),
    new ActionViewModel({
        type: ActionType.SetVariable,
        $title: SmartSalesConstants.DEFAULT_DISABLED_CTA_ACTION_NAME,
        settings: new SetVariableActionSettings({
            variable: 'defaultDisabledCtaMsg',
            value: defaultDisabledCtaMsg,
        }),
    }),
    new ActionViewModel({
        type: ActionType.ExecuteScript,
        $title: 'smartSalesMessage',
        settings: new ExecuteScriptActionSettings({
            function: 'run',
            source: 'const run = (wabaResponse, whatsappCta, catalogUrl, isCtaEnabled, defaultDisabledCtaMsg) => {\n\n    const { link, shortnedLink } = convertToJSON(catalogUrl);\n\n    const defaultMessage = `${defaultDisabledCtaMsg} ${shortnedLink ? shortnedLink : link}`;\n\n    let message = { type: "text/plain", content: defaultMessage };\n\n    wabaResponse = convertToJSON(wabaResponse);\n\n    whatsappCta = convertToJSON(whatsappCta);\n\n\n\n    if (isCtaEnabled === "true" && wabaResponse && wabaResponse.status === "success") {\n\n        message = {\n\n            type: "application/json",\n\n            content: {\n\n                type: "interactive", interactive: {\n\n                    type: "cta_url", body: {\n\n                        text: whatsappCta.body, // max 1000 carácteres\n\n                    }, action: {\n\n                        name: "cta_url", parameters: {\n\n                            display_text: whatsappCta.button, // max 20 carácteres\n\n                            url: link,\n\n                        },\n\n                    },\n\n                },\n\n            }\n\n        };\n\n        if (whatsappCta.header) {\n\n            message.content.interactive.header = { type: "text", text: whatsappCta.header };\n\n        } if (whatsappCta.footer) {\n\n            message.content.interactive.footer = { text: whatsappCta.footer };\n\n        }\n\n    }\n\n    return message;\n\n};\n\n\n\nfunction convertToJSON(dataToConvert) {\n\n    if (dataToConvert && typeof dataToConvert !== "object") {\n\n        dataToConvert = JSON.parse(dataToConvert);\n\n    }\n\n    return dataToConvert;\n\n}',
            inputVariables: [
                'smartSalesWabaResponse',
                'smartSalesWhatsappCta',
                'smartSalesCatalogUrlResponse',
                'isCtaEnabled',
                'defaultDisabledCtaMsg',
            ],
            outputVariable: 'smartSalesMessage',
        }),
    }),
    new ActionViewModel({
        type: ActionType.ExecuteScript,
        $title: 'smartSalesMessageContent',
        settings: new ExecuteScriptActionSettings({
            function: 'run',
            source: 'function run(message) {\n    if (typeof message !== "object") {\n        message = JSON.parse(message);\n    }\n\n    return message.content;\n}',
            inputVariables: ['smartSalesMessage'],
            outputVariable: 'smartSalesMessageContent',
        }),
    }),
];
export const smartSalesLeavingCustomActions = [
    new ActionViewModel({
        type: ActionType.ExecuteScript,
        $title: 'smartSalesUserHasProduct',
        settings: new ExecuteScriptActionSettings({
            function: 'run',
            source: 'function run(currentCart) {\n    try {\n        if (currentCart && typeof currentCart !== "object") {\n            currentCart = JSON.parse(currentCart.replace(/\\\\([\\s\\S])/g, "$1"));\n        }\n\n        if (currentCart && currentCart.length) {\n            return true;\n        }\n\n        return false;\n    } catch(e) {\n        return false;\n    }\n}',
            inputVariables: ['contact.extras.currentCart'],
            outputVariable: 'smartSalesUserHasProduct',
        }),
    }),
    new ActionViewModel({
        type: ActionType.ExecuteScript,
        $title: 'smartSalesUserResponse',
        settings: new ExecuteScriptActionSettings({
            function: 'run',
            source: `function run(inputContent, userHasProduct) {\n    try {\n        if (!inputContent || !inputContent.length) {\n            return "${SmartSalesConstants.USER_RESPONSE_STATUS.INACTIVITY}";\n        }\n\n        const regexes = [\n            {\n                rule: new RegExp("^(sim|s|yes|si|sí|1)$", "i"),\n                value: "${SmartSalesConstants.USER_RESPONSE_STATUS.ACCEPT_TO_BUY}",\n            },\n            {\n                rule: new RegExp("^(n[ãa]o?|no|n|2)$", "i"),\n                value: "${SmartSalesConstants.USER_RESPONSE_STATUS.REFUSED_TO_BUY}",\n            },\n        ];\n\n        let matchedRegex = "${SmartSalesConstants.USER_RESPONSE_STATUS.UNDEFINED}";\n\n        if (userHasProduct) {\n            regexes.forEach(regexObj => {\n                if (regexObj.rule.test(inputContent)) {\n                    matchedRegex = regexObj.value;\n                }\n            });\n        }\n\n        return matchedRegex;\n    } catch (e) {\n        return "${SmartSalesConstants.USER_RESPONSE_STATUS.UNDEFINED}";\n    }\n}`,
            inputVariables: ['input.content', 'smartSalesUserHasProduct'],
            outputVariable: 'smartSalesUserResponse',
        }),
    }),
    new ActionViewModel({
        type: ActionType.ExecuteScript,
        $title: 'SET Confirmation Tracking',
        settings: new ExecuteScriptActionSettings({
            function: 'run',
            source: `const run = (smartSalesUserResponse, input) => {\n    const isUndefined = "${SmartSalesConstants.USER_RESPONSE_STATUS.UNDEFINED}" === smartSalesUserResponse;\n\n    return {\n        category: trackings[smartSalesUserResponse],\n        action: isUndefined? input : "Selecao"\n    };\n};\nconst trackings = {\n    "${SmartSalesConstants.USER_RESPONSE_STATUS.ACCEPT_TO_BUY}": "smart-sales-confirmacao-pedido-sim",\n    "${SmartSalesConstants.USER_RESPONSE_STATUS.REFUSED_TO_BUY}": "smart-sales-confirmacao-pedido-nao",\n    "${SmartSalesConstants.USER_RESPONSE_STATUS.INACTIVITY}": "smart-sales-confirmacao-pedido-inatividade",\n    "${SmartSalesConstants.USER_RESPONSE_STATUS.UNDEFINED}": "smart-sales-confirmacao-pedido-excecao"\n}`,
            inputVariables: ['smartSalesUserResponse', 'input.content'],
            outputVariable: 'smartSalesConfirmOrderTracking',
        }),
    }),
    new ActionViewModel({
        type: ActionType.TrackEvent,
        $title: 'Smart Sales tracking',
        $invalid: false,
        settings: new TrackEventActionSettings({
            action: '{{smartSalesConfirmOrderTracking@action}}',
            category: '{{smartSalesConfirmOrderTracking@category}}',
        }),
    }),
];
